import { getAwaitContinueAction } from 'automaton/actions/AwaitPopupAction'
import { getBonusMultiplierAction } from 'automaton/actions/BonusMultiplierAction'
import { getDelayAction } from 'automaton/actions/DelayAction'
import { getReelSpinAction } from 'automaton/actions/ReelSpinAction'
import { getRequestFreeSpinAction } from 'automaton/actions/RequestFreeSpinAction'
import { getFreespinEndDelayState } from 'automaton/states/FreespinEndDelayState'
import { getFreespinEndState } from 'automaton/states/FreespinsEndState'
import { getFreespinsRespinState } from 'automaton/states/FreespinsRespinState'
import { getFreespinsWinState } from 'automaton/states/FreespinsWinState'
import { getSpreadState } from 'automaton/states/SpreadState'
import { getStickyState } from 'automaton/states/StickyState'
import { signal } from 'services/SignalsService'
import { delayAfterFS } from 'settings/custom/freespins'

import { getCascadeState } from './CascadeState'

export function getFreespinsSpinState() {
  const spinModel = game.models.SpinModel.get()
  const freespinModel = game.models.FreespinModel.get()
  const cascadeModel = game.models.CascadeModel.get()
  const winModel = game.models.WinModel.get()
  const bonusMultiplierModel = game.models.BonusMultiplierModel.get()
  signal.dispatch('FREEBET:Enabled', false)

  const name = 'SPIN'
  const actions = [
    game.models.GameModel.showBonusPopupContinue
      ? getAwaitContinueAction()
      : getDelayAction(0.1),

    getBonusMultiplierAction(bonusMultiplierModel.skip),
    getRequestFreeSpinAction(),
    game.models.GameModel.requestAgainAllowed
      ? getDelayAction(0.1)
      : getReelSpinAction(),
  ]
  const transition = () =>
    game.models.GameModel.requestAgainAllowed
      ? getFreespinEndState()
      : cascadeModel.all > -1
        ? getCascadeState()
        : freespinModel.stickyPosition.length
          ? getStickyState()
          : winModel.winLines.length
            ? getFreespinsWinState()
            : spinModel.respin.length
              ? getFreespinsRespinState()
              : winModel.expendingMatrix.length
                ? getSpreadState()
                : freespinModel.left
                  ? getFreespinsSpinState()
                  : delayAfterFS
                    ? getFreespinEndDelayState()
                    : getFreespinEndState()

  return {
    name,
    actions,
    transition,
  }
}
